export const HOLDING_UNIT_NOT_FOUND = 'HOLDING_UNIT_NOT_FOUND';
export const FIXED_ID_ASSET_NOT_FOUND = 'FIXED_ID_ASSET_NOT_FOUND';
export const FIXED_ID_ASSET_STATE_INVALID = 'FIXED_ID_ASSET_STATE_INVALID';
export const FIXED_ID_ASSET_MASTER_TARE_REQUIRED = 'FIXED_ID_ASSET_MASTER_TARE_REQUIRED';
export const HOLDING_UNIT_STATUS_INVALID = 'HOLDING_UNIT_STATUS_INVALID';
export const HOLDING_UNIT_SHIPPED_IMMUTABLE = 'HOLDING_UNIT_SHIPPED_IMMUTABLE';
export const HOLDING_UNIT_RETIRED = 'HOLDING_UNIT_RETIRED';
export const HOLDING_UNIT_RESERVED = 'HOLDING_UNIT_RESERVED';
export const HOLDING_UNIT_ALREADY_RESERVED = 'HOLDING_UNIT_ALREADY_RESERVED';
export const HOLDING_UNIT_SCANNABLE_IDENTIFIER_DUPLICATE =
  'HOLDING_UNIT_SCANNABLE_IDENTIFIER_DUPLICATE';
export const MATERIAL_CHANGE_NOT_ALLOWED = 'MATERIAL_CHANGE_NOT_ALLOWED';
export const UNIT_NOT_EMPTY = 'UNIT_NOT_EMPTY';
export const WEIGHT_DELTA_INVALID = 'WEIGHT_DELTA_INVALID';
export const WEIGHT_BELOW_TARE = 'WEIGHT_BELOW_TARE';
export const HOLDING_UNIT_WEIGHT_HISTORY_INCONSISTENT =
  'HOLDING_UNIT_WEIGHT_HISTORY_INCONSISTENT';
export const NET_NEGATIVE = 'NET_NEGATIVE';
export const TRANSFER_INSUFFICIENT_NET = 'TRANSFER_INSUFFICIENT_NET';
export const TRANSFER_SAME_UNIT = 'TRANSFER_SAME_UNIT';
export const RESERVATION_CONFLICT = 'RESERVATION_CONFLICT';
export const LOAD_SESSION_NOT_FOUND = 'LOAD_SESSION_NOT_FOUND';
export const LOAD_SESSION_STATUS_INVALID = 'LOAD_SESSION_STATUS_INVALID';
export const LOAD_SESSION_GROUP_NOT_FOUND = 'LOAD_SESSION_GROUP_NOT_FOUND';
export const LOAD_SESSION_INVALID_CAPTURE_MODE = 'LOAD_SESSION_INVALID_CAPTURE_MODE';
export const LOAD_SESSION_AUTOPICK_NO_CANDIDATE = 'LOAD_SESSION_AUTOPICK_NO_CANDIDATE';
export const LOAD_SESSION_SCAN_REWEIGH_TARE_REQUIRED = 'LOAD_SESSION_SCAN_REWEIGH_TARE_REQUIRED';
export const LOAD_SESSION_MEASURED_DISCREPANCY_NOT_ELIGIBLE =
  'LOAD_SESSION_MEASURED_DISCREPANCY_NOT_ELIGIBLE';
export const LOAD_SESSION_MEASURED_DISCREPANCY_UNRESOLVED =
  'LOAD_SESSION_MEASURED_DISCREPANCY_UNRESOLVED';
export const HOLDING_UNIT_VERSION_CONFLICT = 'HOLDING_UNIT_VERSION_CONFLICT';
export const HOLDING_UNIT_PROJECTION_GAP = 'HOLDING_UNIT_PROJECTION_GAP';
export const HOLDING_UNIT_PROJECTION_DIVERGED = 'HOLDING_UNIT_PROJECTION_DIVERGED';
export const HOLDING_UNIT_PROJECTION_FAILED = 'HOLDING_UNIT_PROJECTION_FAILED';
export const HOLDING_UNIT_PROJECTION_PENDING = 'HOLDING_UNIT_PROJECTION_PENDING';
export const HOLDING_UNIT_REASON_REQUIRED = 'HOLDING_UNIT_REASON_REQUIRED';
export const WEIGHT_CORRECTION_REASON_REQUIRED = 'WEIGHT_CORRECTION_REASON_REQUIRED';
export const ADJUSTMENT_REASON_REQUIRED = 'ADJUSTMENT_REASON_REQUIRED';
export const HOLDING_UNIT_TOLERANCE_PROFILE_NOT_FOUND = 'HOLDING_UNIT_TOLERANCE_PROFILE_NOT_FOUND';
export const HOLDING_UNIT_ASSISTED_MATCHING_INVALID_INPUT =
  'HOLDING_UNIT_ASSISTED_MATCHING_INVALID_INPUT';
export const DEV_POLICY_WRITE_DISABLED = 'DEV_POLICY_WRITE_DISABLED';
export const HOLDING_UNITS_POLICY_WRITE_BLOCKED_HYBRID =
  'HOLDING_UNITS_POLICY_WRITE_BLOCKED_HYBRID';

export const holdingUnitErrorCodes = [
  HOLDING_UNIT_NOT_FOUND,
  FIXED_ID_ASSET_NOT_FOUND,
  FIXED_ID_ASSET_STATE_INVALID,
  FIXED_ID_ASSET_MASTER_TARE_REQUIRED,
  HOLDING_UNIT_STATUS_INVALID,
  HOLDING_UNIT_SHIPPED_IMMUTABLE,
  HOLDING_UNIT_RETIRED,
  HOLDING_UNIT_RESERVED,
  HOLDING_UNIT_ALREADY_RESERVED,
  HOLDING_UNIT_SCANNABLE_IDENTIFIER_DUPLICATE,
  MATERIAL_CHANGE_NOT_ALLOWED,
  UNIT_NOT_EMPTY,
  WEIGHT_DELTA_INVALID,
  WEIGHT_BELOW_TARE,
  HOLDING_UNIT_WEIGHT_HISTORY_INCONSISTENT,
  NET_NEGATIVE,
  TRANSFER_INSUFFICIENT_NET,
  TRANSFER_SAME_UNIT,
  RESERVATION_CONFLICT,
  LOAD_SESSION_NOT_FOUND,
  LOAD_SESSION_STATUS_INVALID,
  LOAD_SESSION_GROUP_NOT_FOUND,
  LOAD_SESSION_INVALID_CAPTURE_MODE,
  LOAD_SESSION_AUTOPICK_NO_CANDIDATE,
  LOAD_SESSION_SCAN_REWEIGH_TARE_REQUIRED,
  LOAD_SESSION_MEASURED_DISCREPANCY_NOT_ELIGIBLE,
  LOAD_SESSION_MEASURED_DISCREPANCY_UNRESOLVED,
  HOLDING_UNIT_VERSION_CONFLICT,
  HOLDING_UNIT_PROJECTION_GAP,
  HOLDING_UNIT_PROJECTION_DIVERGED,
  HOLDING_UNIT_PROJECTION_FAILED,
  HOLDING_UNIT_PROJECTION_PENDING,
  HOLDING_UNIT_REASON_REQUIRED,
  WEIGHT_CORRECTION_REASON_REQUIRED,
  ADJUSTMENT_REASON_REQUIRED,
  HOLDING_UNIT_TOLERANCE_PROFILE_NOT_FOUND,
  HOLDING_UNIT_ASSISTED_MATCHING_INVALID_INPUT,
  DEV_POLICY_WRITE_DISABLED,
  HOLDING_UNITS_POLICY_WRITE_BLOCKED_HYBRID,
] as const;

export type HoldingUnitErrorCode = (typeof holdingUnitErrorCodes)[number];
